import { useMutation } from '@tanstack/react-query';

import { CustomerRequest } from '@/models';
import { RegisterCustomerRequest, getSMPBackendAPIAdmin } from '@/proxy';

const toRequest = (customer: CustomerRequest): RegisterCustomerRequest => ({
  company: customer.company,
  street: customer.street,
  zip: customer.zip,
  city: customer.city,
  country: customer.country,
  firstName: customer.firstName,
  lastName: customer.lastName,
  email: customer.email,
  phone: customer.phone,
});

function createCustomer(customer: CustomerRequest) {
  const data = toRequest(customer);
  return getSMPBackendAPIAdmin().customersControllerCreateV1(data);
}

export function useCreateCustomer() {
  return useMutation({ mutationFn: createCustomer });
}
